// @ts-nocheck
import {
    PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_DATA_CHANGED,
    PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_DATA_CLEARED,
    PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_EXPANDED_ROWS_CHANGED,
    PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_EXPANDED_ROWS_CLEARED,
    PLAYER_ACTIVITY_REPORTS_SECONDARY_GROUP_DATA_CHANGED,
    PLAYER_ACTIVITY_REPORTS_SECONDARY_GROUP_DATA_CLEARED,
} from '../types';

const initialState = {
    mainGroupData: [],
    expandedMainGroupRows: [],
    secondaryGroupData: {},
};

const playerActivityReport = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_DATA_CHANGED: {
            return {
                ...state,
                mainGroupData: payload,
            };
        }
        case PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_DATA_CLEARED: {
            return {
                ...state,
                mainGroupData: [],
            };
        }
        case PLAYER_ACTIVITY_REPORTS_SECONDARY_GROUP_DATA_CHANGED: {
            return {
                ...state,
                secondaryGroupData: {
                    ...state.secondaryGroupData,
                    [payload.firstGroupId]: { ...state.secondaryGroupData[payload.firstGroupId], ...payload.data },
                },
            };
        }
        case PLAYER_ACTIVITY_REPORTS_SECONDARY_GROUP_DATA_CLEARED: {
            return {
                ...state,
                secondaryGroupData: {},
            };
        }
        case PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_EXPANDED_ROWS_CHANGED: {
            const found = state.expandedMainGroupRows.includes(payload);
            const newExpandedRows = found
                ? state.expandedMainGroupRows.filter(row => row !== payload)
                : state.expandedMainGroupRows.concat(payload);

            return {
                ...state,
                expandedMainGroupRows: newExpandedRows,
            };
        }
        case PLAYER_ACTIVITY_REPORTS_MAIN_GROUP_EXPANDED_ROWS_CLEARED: {
            return {
                ...state,
                expandedMainGroupRows: [],
            };
        }
        default:
            return state;
    }
};

export default playerActivityReport;
